import { notifications } from '@mantine/notifications'
import { useCallback, useEffect } from 'react'
import { NotificationContent, NotificationTitle } from '../ui/AppUpdateNotification'
import { useAppVersionPoller } from './useAppVersionPoller'

const AUTO_RELOAD_DELAY = 30 // seconds

export function useAppUpdateNotification() {
  const isNewAppVersionAvailable = useAppVersionPoller()

  const handleReload = useCallback(() => {
    window.location.reload()
  }, [])

  useEffect(() => {
    if (!isNewAppVersionAvailable) {
      notifications.hide('app-update-notification')
      return
    }

    const notification = notifications.show({
      id: 'app-update-notification',
      title: <NotificationTitle />,
      message: (
        <NotificationContent
          initialCountdown={AUTO_RELOAD_DELAY}
          onReload={handleReload}
          onCountdownEnd={handleReload}
        />
      ),
      autoClose: false,
      withCloseButton: false,
      withBorder: true,
    })

    return () => {
      notifications.hide(notification)
    }
  }, [handleReload, isNewAppVersionAvailable])

  return null
}
